import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AiChatComponent } from './pages/components/ai-chat/ai-chat.component';
import { PaymentSuccessfulComponent } from './pages/components/payment-successful/payment-successful.component';
import { PaymentFailedComponent } from './pages/components/payment-failed/payment-failed.component';
import { KioskHomepageComponent } from './pages/components/kiosk-homepage/kiosk-homepage.component';
import { DetailPageComponent } from './pages/components/detail-page/detail-page.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    loadChildren: () =>
      import('./pages/tabs/tabs-routing.module').then(
        (m) => m.TabsPageRoutingModule
      ),
  },
  {
    path: 'hotels',
    loadChildren: () =>
      import('./pages/group-hotels/group-hotels.module').then(
        (m) => m.GroupHotelsPageModule
      ),
  },
  {
    path: 'ai-chat',
    loadChildren: () =>
      import('./pages/components/shared.module').then((m) => m.SharedModule),
    component: AiChatComponent,
  },
  {
    path: 'welcome',
    loadChildren: () =>
      import('./pages/welcome/welcome.module').then((m) => m.WelcomePageModule),
  },
  {
    path: 'download',
    loadChildren: () =>
      import('./pages/download/download.module').then(
        (m) => m.DownloadPageModule
      ),
  },
  {
    path: 'blank/:section/:item',
    component: DetailPageComponent,
  },
  {
    path: 'payment-successfull',
    component: PaymentSuccessfulComponent,
  },
  {
    path: 'payment-failed',
    component: PaymentFailedComponent,
  },
  {
    path: 'kiosk',
    component: KioskHomepageComponent,
  },
  {
    path: 'restaurant-booking',
    loadChildren: () =>
      import('./pages/restaurant-booking/restaurant-booking.module').then(
        (m) => m.RestaurantBookingPageModule
      ),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
